export const environment = {
  production: true,
  apiHost: 'https://stage-api.c2keep.com/api/v1',
  signalRApiHost: 'https://stage-api.c2keep.com',
  enableRouteTracing: false
};
